module.exports = __webpack_public_path__ + "img/title3.70be15f6.png";